export default __webpack_public_path__ + "static/media/green_excel_file.04fac9d7.svg";